import ssa_115_1 from "@/assets/studentAwardsRouter/studentAwardsFile/115/ssa_115_1.pdf";
import ssa_115_2 from "@/assets/studentAwardsRouter/studentAwardsFile/115/ssa_115_2.pdf";
import ssa_115_3 from "@/assets/studentAwardsRouter/studentAwardsFile/115/ssa_115_3.pdf";
import ssa_115_4 from "@/assets/studentAwardsRouter/studentAwardsFile/115/ssa_115_4.pdf";
import ssa_115_5 from "@/assets/studentAwardsRouter/studentAwardsFile/115/ssa_115_5.pdf";
import ssa_115_6 from "@/assets/studentAwardsRouter/studentAwardsFile/115/ssa_115_6.pdf";
import ssa_115_7 from "@/assets/studentAwardsRouter/studentAwardsFile/115/ssa_115_7.pdf";
import ssa_115_8 from "@/assets/studentAwardsRouter/studentAwardsFile/115/ssa_115_8.pdf";
import ssa_115_9 from "@/assets/studentAwardsRouter/studentAwardsFile/115/ssa_115_9.pdf";
import ssa_115_10 from "@/assets/studentAwardsRouter/studentAwardsFile/115/ssa_115_10.pdf";
import ssa_115_11 from "@/assets/studentAwardsRouter/studentAwardsFile/115/ssa_115_11.pdf";
import ssa_115_12 from "@/assets/studentAwardsRouter/studentAwardsFile/115/ssa_115_12.pdf";
import ssa_115_13 from "@/assets/studentAwardsRouter/studentAwardsFile/115/ssa_115_13.pdf";
import ssa_115_14 from "@/assets/studentAwardsRouter/studentAwardsFile/115/ssa_115_14.pdf";
import ssa_115_15 from "@/assets/studentAwardsRouter/studentAwardsFile/115/ssa_115_15.pdf";
import ssa_115_16 from "@/assets/studentAwardsRouter/studentAwardsFile/115/ssa_115_16.pdf";
import ssa_115_17 from "@/assets/studentAwardsRouter/studentAwardsFile/115/ssa_115_17.pdf";
import ssa_115_18 from "@/assets/studentAwardsRouter/studentAwardsFile/115/ssa_115_18.pdf";
import ssa_115_19 from "@/assets/studentAwardsRouter/studentAwardsFile/115/ssa_115_19.pdf";
//import ssa_115_20 from "@/assets/studentAwardsRouter/studentAwardsFile/115/ssa_115_20.pdf";
// import ssa_115_21 from "@/assets/studentAwardsRouter/studentAwardsFile/115/ssa_115_21.pdf";
// import ssa_115_22 from "@/assets/studentAwardsRouter/studentAwardsFile/115/ssa_115_22.pdf";
// import ssa_115_23 from "@/assets/studentAwardsRouter/studentAwardsFile/115/ssa_115_23.pdf";
// import ssa_115_24 from "@/assets/studentAwardsRouter/studentAwardsFile/115/ssa_115_24.pdf";
// import ssa_115_25 from "@/assets/studentAwardsRouter/studentAwardsFile/115/ssa_115_25.pdf";
// import ssa_115_26 from "@/assets/studentAwardsRouter/studentAwardsFile/115/ssa_115_26.pdf";
// import ssa_115_27 from "@/assets/studentAwardsRouter/studentAwardsFile/115/ssa_115_27.pdf";
// import ssa_115_28 from "@/assets/studentAwardsRouter/studentAwardsFile/115/ssa_115_28.pdf";
// import ssa_115_29 from "@/assets/studentAwardsRouter/studentAwardsFile/115/ssa_115_29.pdf";
var awardsPath_115 = [
  ssa_115_1,
  ssa_115_2,
  ssa_115_3,
  ssa_115_4,
  ssa_115_5,
  ssa_115_6,
  ssa_115_7,
  ssa_115_8,
  ssa_115_9,
  ssa_115_10,
  ssa_115_11,
  ssa_115_12,
  ssa_115_13,
  ssa_115_14,
  ssa_115_15,
  ssa_115_16,
  ssa_115_17,
  ssa_115_18,
  ssa_115_19,
  //ssa_115_20,
  // ssa_115_21,
  // ssa_115_22,
  // ssa_115_23,
  // ssa_115_24,
  // ssa_115_25,
  // ssa_115_26,
  // ssa_115_27,
  // ssa_115_28,
  // ssa_115_29,
];
export { awardsPath_115 };
